import shopifyGenericDefaults from '../shopify-generic/config.js';

const baseFitmentFields = shopifyGenericDefaults.fitmentSearch.baseFields;

shopifyGenericDefaults.Widgets.map((w) => {
  if (w.name === 'FilterChips' || w.name === 'Facets' || w.name === 'FacetDialog') {
    if (w.ignoreFields) {
      w.ignoreFields.push('wheel_tire_diameter');
    } else {
      w.ignoreFields = ['wheel_tire_diameter'];
    }
  }
  return w;
});

export default {
  includes: ['shopify-generic'],
  ...shopifyGenericDefaults,
  Widgets: [
    ...shopifyGenericDefaults.Widgets.filter((w) => w.name !== 'HomeVehicleWidget_tab'),
    {
      name: 'HomeVehicleWidget_tab',
      type: 'VehicleWidget',
      location: {
        insertAfter: 'p.mfw-hero__subheading',
        class: 'cm_vehicle-widget__home-container',
      },
      template: 'fitmentSearch/homeVehicleWidget',
      columnBreakpoint: 800,
      initCollapsed: !!window.Convermax.config?.ymmInitCollapsed,
      fields: !!window.Convermax.config?.extraFieldsAsFilters && baseFitmentFields,
      isVehicleSelectionIsolated: !!window.Convermax.config?.isVehicleSelectionIsolated,
    },
    {
      name: 'UpsizeDownsizeFacetPanel',
      type: 'FacetPanel',
      fields: ['wheel_tire_diameter'],
      showAllAlways: true,
      disableCollapse: true,
    },
    {
      name: 'WheelTireVehicleInfo',
    },
  ],
};
